<template>
    <Modal v-if="showModal" @close="hide()">
      <h6 slot="header" class="modal-title pl-3">
        <span class="subject">{{form ? form.config_json.form_title : ''}}</span>
      </h6>

      <div class="pl-3 pr-3" slot="body">
        <DynamicForm v-if="form" :locale="$locale" :data="form" :textHelpers="textHelpers" @finished="finished"/>

        <div class="text-center" v-else>
            <div class="spinner-border spinner-border-sm" role="status" style="font-size: 12px;">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
      </div>

      <div slot="footer"></div>
    </Modal>
</template>
<script nonce>
import Modal from '../settings/index/components/Modal.vue';
import DynamicForm from '../dynamic-form/App.vue';

export default { 
    props: {
        locale: String,
        cta: String
    },
    components:{
        Modal, DynamicForm
    },
    data: () => ({
        showModal: false,
        form: null,
        textHelpers: {}
    }),
    methods: {
        show(submission) {
            this.showModal = true;
            this.getForm();
        },
        hide(){
            this.showModal = false;
        },
        getForm() {
            if (window.form) this.form = window.form;
            if (this.form) return;

            this.$axios.get(`/api/v1/form/promotion-form-${this.$locale}`).then(response => {
                this.form = response.data.data;
                this.form.config_json.button_text = this.cta;

                window.form = Object.assign({}, this.form);
            });
        },
        finished(contact) {
            window.contact = Object.assign({}, contact);
            this.hide();
            this.$emit('sendEmail');
        }
    }
}
</script>
<style nonce>
    .modal-footer{
        border-top: 0px !important;
    }

    .muted {
        color: #F70048 !important;
    }

    .subject {
        font-weight: bold;
    }

    .modal-header .close{
        margin-right: 0px;
    }
    .send_button{
        width: 200px;
        margin-right: 15px;
    }
    .description{
        font-size: 15px;
    }
    .modal-content{
        padding-left: 2rem;
        padding-right: 2rem;
        padding-bottom: 3.5rem;
    }
    .modal-header h5{
        font-size: 18px;
    }
    .input_label{
        font-weight: bold;
    }
    .form_header h5 {
        display: none;
    }
    .form-control {
        background-color: #F4F5F6!important;
    }

    .form_header {
        margin-top: 1.5rem;
    }

    input[type=text] {
      height: 40px;
    }
</style>